export const is_valid_email = (email: string) => {
  const re = /\S+@\S+\.\S+/;
  return re.test(email);
};

export const invalid_states = ['AK', 'CA', 'CO', 'DE', 'HI', 'ME', 'NH', 'ND', 'VT', 'WV'];

export const is_valid_zipcode = async (zipcode: string): Promise<string> => {
  if (zipcode === '') return '';
  if (zipcode.length !== 5) return 'Please enter a valid zipcode';
  const response = await fetch(`https://api.zippopotam.us/us/${zipcode}`);
  const re = /^\d{5}$/;
  if (response.status === 404 || !re.test(zipcode)) {
    return 'Please enter a valid zipcode';
  }
  const data = await response.json();
  const state = data.places[0]['atoms abbreviation'];
  if (invalid_states.includes(state)) {
    return "Sorry! We currently don't contract tutors in your area.";
  }
  return '';
};

// Checks if the phone number is in the format +1 (555) 555-5555
export const is_valid_phone_number = (phone: string) => {
  // Create a variable called re that contains a regex test for whether the string contains between 11 and 15 digits
  const re = /^\d{11}$/;
  return re.test(phone);
};
